module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/invoices": {
    "success": {
      "invoices overview loaded": [
        "INDEX_LOAD",
        "INVOICES_OVERVIEW_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/invoices/details": {
    "success": {
      "invoice details loaded": [
        "INDEX_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/invoices/pay": {
    "success": {
      "pay invoice loaded": [
        "INDEX_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/subscriptions": {
    "success": {
      "subscriptions overview loaded": [
        "INDEX_LOAD",
        "SUBSCRIPTIONS_OVERVIEW_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/payment-methods": {
    "success": {
      "payment methods overview loaded": [
        "INDEX_LOAD",
        "PAYMENT_METHODS_OVERVIEW_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/payment-history": {
    "success": {
      "payment history overview loaded": [
        "INDEX_LOAD",
        "PAYMENT_HISTORY_OVERVIEW_LOAD",
        "PAYMENT_HISTORY_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/quotes": {
    "success": {
      "quotes overview loaded": [
        "INDEX_LOAD",
        "QUOTES_OVERVIEW_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/quotes/details": {
    "success": {
      "quote details loaded": [
        "INDEX_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/update-payment-method": {
    "success": {
      "update payment method loaded": [
        "INDEX_LOAD"
      ]
    },
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  },
  "/portals/preview": {
    "error": [
      "APP_NOT_INITIALIZED"
    ]
  }
};